import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './TileSmallWithImg.module.css';
import { PromoDangerouslyHtml } from '../promo-dangerously-html/PromoDangerouslyHtml';
import { PromoText } from '../promo-text/PromoText';
import IconSvg from '../widgets/Illustration/IconSvg';

export const TileSmallWithImg = ({ bgColor = 'aubergine01', ...props }) => {
    const containerClass = clsx(styles.tileContainer, `bg${bgColor.charAt(0).toUpperCase() + bgColor.slice(1)}`);
    return (
        <div className={containerClass}>
            {props.icon && (
                <span className={styles.imgContainer}>
                    <IconSvg img={props.icon} />
                </span>
            )}
            {props.title && (
                <div className={styles.title}>
                    <PromoText gradientColor={props.titleGradient} tag="div" variant="h3">
                        {props.title}
                    </PromoText>
                </div>
            )}
            {props.text && <PromoDangerouslyHtml color="gray40" dangerouslyHtml={props.text} tag="div" variant={'subheader'} />}
        </div>
    );
};

TileSmallWithImg.propTypes = {
    icon: PropTypes.object,
    title: PropTypes.string,
    text: PropTypes.string,
};
